export default {
    // Admin / Analytics header button
    "Admin": { translationEng: "Admin", translationJp: "管理" },
    "Admin & Analytics": { translationEng: "Admin & Analytics", translationJp: "管理と分析" },
    // Product Tour Keys
    "New Chat": { translationEng: "New Chat", translationJp: "新しいチャット" },
    "Chat History": { translationEng: "Chat History", translationJp: "チャット履歴" },
    "Submit Feedback": { translationEng: "Submit Feedback", translationJp: "フィードバックを送信" },
    "Toggle Sidebar": { translationEng: "Toggle Sidebar", translationJp: "サイドバーの切り替え" },
    "Language Selection": { translationEng: "Language Selection", translationJp: "言語選択" },
    "User Profile": { translationEng: "User Profile", translationJp: "ユーザープロファイル" },
    "Model Selection": { translationEng: "Model Selection", translationJp: "モデル選択" },
    "Ask Questions": { translationEng: "Ask Questions", translationJp: "質問する" },
    "Start a fresh conversation with the chatbot": { translationEng: "Start a fresh conversation with the chatbot", translationJp: "チャットボットと新しい会話を開始します" },
    "Access your previous conversations": { translationEng: "Access your previous conversations", translationJp: "過去の会話にアクセスします" },
    "Share your experience and help us improve": { translationEng: "Share your experience and help us improve", translationJp: "体験を共有し、改善にご協力ください" },
    "Collapse or expand the sidebar for more space": { translationEng: "Collapse or expand the sidebar for more space", translationJp: "サイドバーを折りたたむか展開してスペースを確保します" },
    "Choose your preferred language": { translationEng: "Choose your preferred language", translationJp: "希望の言語を選択してください" },
    "Access your profile and logout options": { translationEng: "Access your profile and logout options", translationJp: "プロフィールとログアウトオプションにアクセスします" },
    "Select the vehicle model for your conversation": { translationEng: "Select the vehicle model for your conversation", translationJp: "会話に使用する車両モデルを選択してください"},
    "Type your questions here and get instant responses": { translationEng: "Type your questions here and get instant responses", translationJp: "ここに質問を入力して、すぐに回答を得られます" },
    "Next": { translationEng: "Next", translationJp: "次へ" },
    "Previous": { translationEng: "Previous", translationJp: "前へ" },
    "Finish": { translationEng: "Finish", translationJp: "終了" },

    // Existing Keys
    "New chat": {
        translationEng: "New chat",
        translationJp: "新しいチャット",
        translationIn: "Percakapan Baru",
        translationSl: "නව කතාබස්",
        translationNp: "नयाँ कुराकानी",
        translationVn: "Trò chuyện mới",
        translationPh: "Bagong chat",
        translationBd: "নতুন চ্যাট"
    },
    "We value your feedback": {
        translationEng: "We value your feedback",
        translationJp: "ご意見をお聞かせください",
        translationIn: "Kami menghargai masukan Anda",
        translationSl: "ඔබේ අදහස් අපට වැදගත්ය",
        translationNp: "हामी तपाईंको प्रतिक्रिया कदर गर्छौं",
        translationVn: "Chúng tôi trân trọng phản hồi của bạn",
        translationPh: "Pinahahalagahan namin ang iyong feedback",
        translationBd: "আমরা আপনার মতামতকে মূল্য দিই"
    },
    "Submit Feedback": {
        translationEng: "Submit Feedback",
        translationJp: "フィードバックを送信する",
        translationIn: "Ajukan Masukan",
        translationSl: "ප්‍රතිචාර ඉදිරිපත් කරන්න",
        translationNp: "प्रतिक्रिया पेश गर्नुहोस्",
        translationVn: "Gửi phản hồi",
        translationPh: "Isumite ang Feedback",
        translationBd: "মতামত জমা দিন"
    },
    "Mandatory": {
        translationEng: "Mandatory",
        translationJp: "必須",
        translationIn: "Wajib",
        translationSl: "අනිවාර්යයි",
        translationNp: "अनिवार्य",
        translationVn: "Bắt buộc",
        translationPh: "Obligado",
        translationBd: "আবশ্যক"
    },
    "Optional": {
        translationEng: "Optional",
        translationJp: "任意",
        translationIn: "Opsional",
        translationSl: "විකල්ප",
        translationNp: "वैकल्पिक",
        translationVn: "Tùy chọn",
        translationPh: "Opsyonal",
        translationBd: "ঐচ্ছিক"
    },
    "Describe your problem": {
        translationEng: "Describe your problem",
        translationJp: "問題の詳細を",
        translationIn: "Silakan jelaskan permasalahan Anda",
        translationSl: "ඔබගේ ගැටලුව විස්තර කරන්න",
        translationNp: "आफ्नो समस्या वर्णन गर्नुहोस्",
        translationVn: "Mô tả vấn đề của bạn",
        translationPh: "Ilarawan ang iyong problema",
        translationBd: "আপনার সমস্যাটি বর্ণনা করুন"
    },
    "How can I assist you today?": {
        translationEng: "How can I assist you today?",
        translationJp: "本日はどのようなご用件でしょうか？",
        translationIn: "Bagaimana saya dapat membantu Anda hari ini?",
        translationSl: "මම අද ඔබට කෙසේ උදව් කළ හැකිද?",
        translationNp: "म म आज तपाईंलाई कसरी सहयोग गर्न सक्छु?",
        translationVn: "Tôi có thể giúp gì cho bạn hôm nay?",
        translationPh: "Paano kita matutulungan ngayon?",
        translationBd: "আমি আজ কীভাবে আপনাকে সাহায্য করতে পারি?"
    },
    "Select Model": {
        translationEng: "Select Model",
        translationJp: "モデルを選択します。",
        translationIn: "Pilih Model",
        translationSl: "මාදිලිය තෝරන්න",
        translationNp: "मोडेल चयन गर्नुहोस्",
        translationVn: "Chọn mô hình",
        translationPh: "Piliin ang Modelo",
        translationBd: "মডেল নির্বাচন করুন"
    },
    "Please select a model from the dropdown to continue.": {
        translationEng: "Please select a model from the dropdown to continue.",
        translationJp: "続行するには、ドロップダウンからモデルを選択してください。",
        translationIn: "Silakan pilih model dari dropdown untuk melanjutkan.",
        translationSl: "ඉදිරියට යාමට කරුණාකර පතන මෙනුවෙන් ආකෘතියක් තෝරන්න.",
        translationNp: "जारी राख्न कृपया ड्रपडाउनबाट मोडेल चयन गर्नुहोस्।",
        translationVn: "Vui lòng chọn mô hình từ menu thả xuống để tiếp tục.",
        translationPh: "Mangyaring pumili ng modelo mula sa dropdown upang magpatuloy.",
        translationBd: "চালিয়ে যেতে ড্রপডাউন থেকে একটি মডেল নির্বাচন করুন।"
    },
    "Please select a year from the dropdown to continue.": {
        translationEng: "Please select a year from the dropdown to continue.",
        translationJp: "続行するには、ドロップダウンから年式を選択してください。",
        translationIn: "Silakan pilih tahun dari dropdown untuk melanjutkan.",
        translationSl: "ඉදිරියට යාමට කරුණාකර පතන මෙනුවෙන් වර්ෂයක් තෝරන්න.",
        translationNp: "जारी राख्न कृपया ड्रपडाउनबाट वर्ष चयन गर्नुहोस्।",
        translationVn: "Vui lòng chọn năm từ menu thả xuống để tiếp tục.",
        translationPh: "Mangyaring pumili ng taon mula sa dropdown upang magpatuloy.",
        translationBd: "চালিয়ে যেতে ড্রপডাউন থেকে একটি বছর নির্বাচন করুন।"
    },
    "Select Engine": {
        translationEng: "Select Engine",
        translationJp: "エンジンを選択します。",
        translationIn: "Pilih Mesin",
        translationSl: "ඉන්ජිම තෝරන්න",
        translationNp: "इन्जिन चयन गर्नुहोस्",
        translationVn: "Chọn động cơ",
        translationPh: "Piliin ang Engine",
        translationBd: "ইঞ্জিন নির্বাচন করুন"
    }
    ,
    "Help us shape a better experience by sharing your feedback!": {
        translationEng: "Share your feedback and help us make your experience better.",
        translationJp: "フィードバックを共有して、より良い体験づくりにご協力ください。",
        translationIn: "Bantu kami menciptakan pengalaman yang lebih baik dengan membagikan masukan Anda!",
        translationSl: "ඔබගේ අදහස් බෙදා ගෙන හොඳ අත්දැකීමක් ඇති කිරීමට උදව් කරන්න!",
        translationNp: "आफ्नो प्रतिक्रिया साझा गरेर राम्रो अनुभव बनाउन हामीलाई मद्दत गर्नुहोस्!",
        translationVn: "Giúp chúng tôi cải thiện trải nghiệm bằng cách chia sẻ phản hồi của bạn!",
        translationPh: "Tulungan kaming bumuo ng mas mahusay na karanasan sa pamamagitan ng pagbabahagi ng iyong feedback!",
        translationBd: "আপনার মতামত শেয়ার করে আমাদের উন্নত অভিজ্ঞতা গড়তে সাহায্য করুন!"
    },
    "Enter your feedback": {
        translationEng: "Enter your feedback",
        translationJp: "フィードバックを伺ってもよろしいでしょうか？",
        translationIn: "Masukkan masukan Anda",
        translationSl: "ඔබේ ප්‍රතිචාර ඇතුළත් කරන්න",
        translationNp: "आफ्नो प्रतिक्रिया प्रविष्ट गर्नुहोस्",
        translationVn: "Nhập phản hồi của bạn",
        translationPh: "Ilagay ang iyong feedback",
        translationBd: "আপনার মতামত লিখুন"
    }
    ,
    "Close": {
        translationEng: "Close",
        translationJp: "クローズ",
        translationIn: "Tutup",
        translationSl: "වසන්න",
        translationNp: "बन्द गर्नुहोस्",
        translationVn: "Đóng",
        translationPh: "Isara",
        translationBd: "বন্ধ করুন"
    },
    "Submit": {
        translationEng: "Submit",
        translationJp: "投稿します",
        translationIn: "Kirim",
        translationSl: "ඉදිරිපත් කරන්න",
        translationNp: "पेश गर्नुहोस्",
        translationVn: "Gửi đi",
        translationPh: "Isumite",
        translationBd: "জমা দিন"
    }
    ,
    "Submitting feedback": {
        translationEng: "Submitting feedback",
        translationJp: "フィードバックを送信中",
        translationIn: "Mengirim masukan",
        translationSl: "ප්‍රතිචාර යැවෙමින් පවතී",
        translationNp: "प्रतिक्रिया पेश गर्दै",
        translationVn: "Đang gửi phản hồi",
        translationPh: "Isinusumite ang feedback",
        translationBd: "মতামত জমা দেওয়া হচ্ছে"
    },
    "Please wait": {
        translationEng: "Please wait",
        translationJp: "少々お待ちください",
        translationIn: "Mohon tunggu",
        translationSl: "කරුණාකර රැඳී සිටින්න",
        translationNp: "कृपया पर्खनुहोस्",
        translationVn: "Vui lòng chờ",
        translationPh: "Paki hintay",
        translationBd: "অনুগ্রহ করে অপেক্ষা করুন"
    },
    "Feedback submitted": {
        translationEng: "Feedback submitted",
        translationJp: "フィードバックが送信されました",
        translationIn: "Masukan berhasil dikirim",
        translationSl: "ප්‍රතිචාර යැවීම සම්පූර්ණයි",
        translationNp: "प्रतिक्रिया पेश गरिएको छ",
        translationVn: "Phản hồi đã được gửi",
        translationPh: "Naisumite na ang feedback",
        translationBd: "মতামত জমা দেওয়া হয়েছে"
    },
    "Thank you for your feedback!": {
        translationEng: "Thank you for your feedback!",
        translationJp: "フィードバックをありがとうございます！",
        translationIn: "Terima kasih atas masukan Anda!",
        translationSl: "ඔබේ ප්‍රතිචාර සඳහා ස්තුතියි!",
        translationNp: "तपाईंको प्रतिक्रियाको लागि धन्यवाद!",
        translationVn: "Cảm ơn bạn đã phản hồi!",
        translationPh: "Salamat sa iyong feedback!",
        translationBd: "আপনার মতামতের জন্য ধন্যবাদ!"
    }
    ,
    "Submission failed": {
        translationEng: "Submission failed",
        translationJp: "送信に失敗しました",
        translationIn: "Pengiriman gagal",
        "translationSl": "ඉදිරිපත් කිරීම අසාර්ථක විය",
        "translationNp": "पेश गर्न असफल भयो",
        "translationVn": "Gửi thất bại",
        "translationPh": "Nabigo ang pagsusumite",
        "translationBd": "জমা দিতে ব্যর্থ হয়েছে"
    },
    "Something went wrong. Please try again.": {
        translationEng: "Something went wrong. Please try again.",
        translationJp: "何か問題が発生しました。もう一度お試しください。",
        translationIn: "Terjadi kesalahan. Mohon coba lagi.",
        "translationSl": "යමක් වැරදී ඇත. නැවත උත්සාහ කරන්න.",
        "translationNp": "केही गलत भयो। कृपया पुनः प्रयास गर्नुहोस्।",
        "translationVn": "Đã xảy ra lỗi. Vui lòng thử lại.",
        "translationPh": "May nangyaring mali. Pakiulit.",
        "translationBd": "কিছু ভুল হয়েছে। অনুগ্রহ করে আবার চেষ্টা করুন।"
    },
    "Delete": {
        translationEng: "Delete",
        translationJp: "削除します。",
        translationIn: "Hapus",
        translationSl: "මකන්න",
        translationNp: "हटाउनुहोस्",
        translationVn: "Xóa",
        translationPh: "Tanggalin",
        translationBd: "মুছুন"
    },
    "Are you sure you want to delete this chat?": {
        translationEng: "Are you sure you want to delete this chat?",
        translationJp: "このチャットを削除してもよろしいでしょうか？",
        translationIn: "Apakah Anda yakin ingin menghapus percakapan ini?",
        translationSl: "ඔබට මෙම කතාබස් මකන්න අවශ්‍ය බව විශ්වාසද?",
        translationNp: "के तपाईं यो कुराकानी मेटाउन चाहनुहुन्छ?",
        translationVn: "Bạn có chắc chắn muốn xóa cuộc trò chuyện này không?",
        translationPh: "Sigurado ka bang gusto mong tanggalin ang chat na ito?",
        translationBd: "আপনি কি নিশ্চিতভাবে এই চ্যাটটি মুছে ফেলতে চান?"
    },
    "Logout": {
        translationEng: "Logout",
        translationJp: "ログアウト",
        translationIn: "Keluar",
        translationSl: "පිටවෙන්න",
        translationNp: "लग आउट गर्नुहोस्",
        translationVn: "Đăng xuất",
        translationPh: "Mag-logout",
        translationBd: "লগ আউট"
    },
    "Select Language": {
        translationEng: "Select Language",
        translationJp: "言語を選択します。",
        translationIn: "Pilih Bahasa",
        translationSl: "භාෂාව තෝරන්න",
        translationNp: "भाषा चयन गर्नुहोस्",
        translationVn: "Chọn ngôn ngữ",
        translationPh: "Piliin ang Wika",
        translationBd: "ভাষা নির্বাচন করুন"
    },
    "Close Sidebar": {
        translationEng: "Close Sidebar",
        translationJp: "サイドバーを閉じます。",
        translationIn: "Tutup Sidebar",
        translationSl: "ඉවතලන්න පැති තීරුව",
        translationNp: "साइडबार बन्द गर्नुहोस्",
        translationVn: "Đóng thanh bên",
        translationPh: "Isara ang Sidebar",
        translationBd: "সাইডবার বন্ধ করুন"
    },
    "Copy": {
        translationEng: "Copy",
        translationJp: "コピー",
        translationIn: "Salin",
        translationSl: "පිටපත් කරන්න",
        translationNp: "प्रतिलिपि गर्नुहोस्",
        translationVn: "Sao chép",
        translationPh: "Kopyahin",
        translationBd: "কপি করুন"
    },
    "Save response": {
        translationEng: "Save response",
        translationJp: "対応を保存します。",
        translationIn: "Simpan jawaban",
        translationSl: "ප්‍රතිචාර සුරකින්න",
        translationNp: "जवाफ सुरक्षित गर्नुहोस्",
        translationVn: "Lưu phản hồi",
        translationPh: "I-save ang sagot",
        translationBd: "উত্তর সংরক্ষণ করুন"
    },
    "Bad response": {
        translationEng: "Bad response",
        translationJp: "悪い対応",
        translationIn: "Jawaban buruk",
        translationSl: "නරක පිළිතුරක්",
        translationNp: "खराब प्रतिक्रिया",
        translationVn: "Phản hồi tệ",
        translationPh: "Masamang sagot",
        translationBd: "খারাপ উত্তর"
    },
    "Good response": {
        translationEng: "Good response",
        translationJp: "良い対応",
        translationIn: "Jawaban baik",
        translationSl: "හොඳ පිළිතුරක්",
        translationNp: "राम्रो प्रतिक्रिया",
        translationVn: "Phản hồi tốt",
        translationPh: "Magandang sagot",
        translationBd: "ভাল উত্তর"
    },
    "Deleting Chat": {
        translationEng: "Deleting Chat",
        translationJp: "チャットは削除中です。",
        translationIn: "Menghapus Percakapan",
        translationSl: "කතාබස් මකාදැමීම සිදුවෙමින් පවතී",
        translationNp: "कुराकानी हटाइँदैछ",
        translationVn: "Đang xóa cuộc trò chuyện",
        translationPh: "Binubura ang chat",
        translationBd: "চ্যাট মুছে ফেলা হচ্ছে"
    },
    "Chat Deleted": {
        translationEng: "Chat Deleted",
        translationJp: "チャットは削除されました",
        translationIn: "Percakapan Dihapus",
        translationSl: "කතාබස් මකා දමා ඇත",
        translationNp: "कुराकानी मेटिएको छ",
        translationVn: "Đã xóa cuộc trò chuyện",
        translationPh: "Natanggal ang chat",
        translationBd: "চ্যাট মুছে ফেলা হয়েছে"
    },
    "Chat Deleted successfully!": {
        translationEng: "Chat Deleted successfully!",
        translationJp: " チャットは正常に削除されました！",
        translationIn: "Percakapan Berhasil Dihapus!",
        translationSl: "කතාබස් සාර්ථකව මකාදමා ඇත!",
        translationNp: "कुराकानी सफलतापूर्वक मेटियो!",
        translationVn: "Đã xóa cuộc trò chuyện thành công!",
        translationPh: "Matagumpay na natanggal ang chat!",
        translationBd: "চ্যাট সফলভাবে মুছে ফেলা হয়েছে!"
    },
    "Today": {
        translationEng: "Today",
        translationJp: "今日",
        translationIn: "Hari ini",
        translationSl: "අද",
        translationNp: "आज",
        translationVn: "Hôm nay",
        translationPh: "Ngayon",
        translationBd: "আজ"
    },
    "Yesterday": {
        translationEng: "Yesterday",
        translationJp: "昨日",
        translationIn: "Kemarin",
        translationSl: "ඊයේ",
        translationNp: "हिजो",
        translationVn: "Hôm qua",
        translationPh: "Kahapon",
        translationBd: "গতকাল"
    },
    "Last 7 Days": {
        translationEng: "Last 7 Days",
        translationJp: "過去7日間 ",
        translationIn: "7 Hari Terakhir",
        translationSl: "පසුගිය දින 7ක්",
        translationNp: "पछिल्ला ७ दिन",
        translationVn: "7 ngày qua",
        translationPh: "Huling 7 araw",
        translationBd: "গত ৭ দিন"
    },
    "Last 30 Days": {
        translationEng: "Last 30 Days",
        translationJp: "過去30日間",
        translationIn: "30 Hari Terakhir",
        translationSl: "පසුගිය දින 30ක්",
        translationNp: "पछिल्ला ३० दिन",
        translationVn: "30 ngày qua",
        translationPh: "Huling 30 araw",
        translationBd: "গত ৩০ দিন"
    },
    "Read aloud": {
        translationEng: "Read aloud",
        translationJp: "読み上げ",
        translationIn: "Baca dengan suara keras",
        translationSl: "මුඛයෙන් කියවන්න",
        translationNp: "ठूलो स्वरमा पढ्नुहोस्",
        translationVn: "Đọc to",
        translationPh: "Basahin ng malakas",
        translationBd: "উচ্চস্বরে পড়ুন"
    },
    "loading": {
        translationEng: "Loading",
        translationJp: "読み込み中",
        translationIn: "memuat",
        translationSl: "පූරණය වෙමින් පවතී",
        translationNp: "लोड हुँदैछ",
        translationVn: "Đang tải",
        translationPh: "Naglo-load",
        translationBd: "লোড হচ্ছে"
    },
    "stop": {
        translationEng: "Stop",
        translationJp: "停止",
        translationIn: "Berhenti",
        translationSl: "නවත්වන්න",
        translationNp: "रोक्नुहोस्",
        translationVn: "Dừng lại",
        translationPh: "Itigil",
        translationBd: "থামুন"
    },
    "Feedback created": {
        translationEng: "Feedback created",
        translationJp: "フィードバックが作成されました",
        translationIn: "Masukan dibuat",
        translationSl: "ප්‍රතිචාර සාදන ලදී",
        translationNp: "प्रतिक्रिया सिर्जना गरिएको छ",
        translationVn: "Phản hồi đã được tạo",
        translationPh: "Nagawa ang feedback",
        translationBd: "মতামত তৈরি হয়েছে"
    },
    "Feedback Shared Successfully": {
        translationEng: "Feedback Shared Successfully",
        translationJp: "フィードバックが正常に共有されました",
        translationIn: "Masukan Berhasil Dibagikan",
        translationSl: "ප්‍රතිචාර සාර්ථකව බෙදාගනු ලැබීය",
        translationNp: "प्रतिक्रिया सफलतापूर्वक साझा गरियो",
        translationVn: "Phản hồi đã được chia sẻ thành công",
        translationPh: "Matagumpay na naibahagi ang feedback",
        translationBd: "মতামত সফলভাবে ভাগ করা হয়েছে"
    },
    "success": {
        translationEng: "Success",
        translationJp: "成功しました",
        translationIn: "Berhasil",
        translationSl: "සාර්ථකයි",
        translationNp: "सफलता",
        translationVn: "Thành công",
        translationPh: "Tagumpay",
        translationBd: "সফলতা"
    },
    "24/7 Availability": {
        translationEng: "24/7 Availability",
        translationJp: "24/7の対応",
        translationIn: "Tersedia 24/7",
        translationSl: "දින 24 පැය 7ක් ලබා ගත හැකියි",
        translationNp: "२४/७ उपलब्धता",
        translationVn: "Sẵn có 24/7",
        translationPh: "Magagamit 24/7",
        translationBd: "২৪/৭ উপলব্ধ"
    },
    "Instant Response": {
        translationEng: "Instant Response",
        translationJp: "即時応答",
        translationIn: "Respon Instan",
        translationSl: "ක්ෂණික ප්‍රතිචාර",
        translationNp: "तत्काल प्रतिक्रिया",
        translationVn: "Phản hồi tức thì",
        translationPh: "Agarang Tugon",
        translationBd: "তাৎক্ষণিক প্রতিক্রিয়া"
    },
    "Consistency": {
        translationEng: "Consistency",
        translationJp: "一貫性のある応答",
        translationIn: "Konsistensi",
        translationSl: "සංසන්දනය",
        translationNp: "संगति",
        translationVn: "Tính nhất quán",
        translationPh: "Pagkakapare-pareho",
        translationBd: "ধারাবাহিকতা"
    },
    "Scalability": {
        translationEng: "Scalability",
        translationJp: "拡張性",
        translationIn: "Skalabilitas",
        translationSl: "විශාල කිරීමේ හැකියාව",
        translationNp: "विस्तारशीलता",
        translationVn: "Khả năng mở rộng",
        translationPh: "Naaangkop sa paglaki",
        translationBd: "স্কেলেবিলিটি"
    },
    "TIC Chatbots provide round-the-clock support.": {
        translationEng: "DTC Chatbots provide round-the-clock support.",
        translationJp: "DTCチャットボットは、24時間365日サポートを提供します。",
        translationIn: "Chatbot DTC menyediakan dukungan sepanjang waktu.",
        translationSl: "DTC චැට්බොට් 24/7 සහය ලබා දෙයි.",
        translationNp: "DTC च्याटबोटले २४/७ सहयोग प्रदान गर्दछ।",
        translationVn: "DTC Chatbots cung cấp hỗ trợ suốt ngày đêm.",
        translationPh: "Nagbibigay ng suporta 24/7 ang DTC Chatbots.",
        translationBd: "DTC চ্যাটবট ২৪/৭ সাপোর্ট প্রদান করে।"
    },
    "Deliver immediate replies to user inquiries.": {
        translationEng: "Deliver immediate replies to user inquiries.",
        translationJp: "ユーザーの問い合わせに即座に返信します。",
        translationIn: "Memberikan tanggapan langsung terhadap pertanyaan pengguna.",
        translationSl: "පරිශීලක විමසුම්වලට ක්ෂණික පිළිතුරු ලබා දෙන්න.",
        translationNp: "प्रयोगकर्ताका जिज्ञासामा तत्काल जवाफ दिनुहोस्।",
        translationVn: "Đưa ra phản hồi ngay lập tức cho câu hỏi của người dùng.",
        translationPh: "Magbigay ng agarang tugon sa mga tanong ng user.",
        translationBd: "ব্যবহারকারীর প্রশ্নের তাৎক্ষণিক উত্তর প্রদান করুন।"
    },
    "Provide consistent responses & follow scripts.": {
        translationEng: "Provide consistent responses & follow scripts.",
        translationJp: "一貫した応答を提供し、スクリプトに従います。",
        translationIn: "Memberikan respons yang konsisten dan mengikuti skrip.",
        translationSl: "සංසන්දනීය පිළිතුරු ලබා දෙමින් ලිඛිත ක්‍රමවේද අනුව ක්‍රියා කරන්න.",
        translationNp: "संगत जवाफहरू दिनुहोस् र स्क्रिप्टहरू पालना गर्नुहोस्।",
        translationVn: "Cung cấp câu trả lời nhất quán và theo kịch bản.",
        translationPh: "Magbigay ng pare-parehong mga tugon at sundin ang mga script.",
        translationBd: "একই ধরনের উত্তর প্রদান করুন এবং স্ক্রিপ্ট অনুসরণ করুন।"
    },
    "Handle numerous interactions simultaneously.": {
        translationEng: "Handle numerous interactions simultaneously.",
        translationJp: "多数のやり取りを同時に処理します。",
        translationIn: "Menangani banyak interaksi secara bersamaan.",
        translationSl: "එක් වතාවකට බහු සංවාද කළමනාකරණය කරන්න.",
        translationNp: "धेरै अन्तरक्रियाहरूलाई एकै साथ व्यवस्थापन गर्नुहोस्।",
        translationVn: "Xử lý nhiều tương tác đồng thời.",
        translationPh: "Hawakan ang maraming pakikipag-ugnayan nang sabay-sabay.",
        translationBd: "একসাথে একাধিক ইন্টারঅ্যাকশন পরিচালনা করুন।"
    },
    "Login with Microsoft": {
        translationEng: "Login with Microsoft",
        translationJp: "",
        translationIn: "Masuk dengan Microsoft",
        translationSl: "Microsoft සමඟ පිවිසෙන්න",
        translationNp: "Microsoft सँग लग इन गर्नुहोस्",
        translationVn: "Đăng nhập bằng Microsoft",
        translationPh: "Mag-login gamit ang Microsoft",
        translationBd: "Microsoft দিয়ে লগইন করুন"
    },
    "Select Year": {
        translationEng: "Select Year",
        translationJp: "年度を選択",
        translationIn: "Pilih Tahun",
        translationSl: "වර්ෂය තෝරන්න",
        translationNp: "बर्ष चयन गर्नुहोस्",
        translationVn: "Chọn năm",
        translationPh: "Pumili ng Taon",
        translationBd: "বছর নির্বাচন করুন"
    },
    "Select the year of the maintenance manual": {
        translationEng: "Select the year of the maintenance manual",
        translationJp: "整備解説書の年度を選択",
        translationIn: "Pilih tahun buku panduan perawatan.",
        translationSl: "නඩත්තුවේ මාර්ගෝපදේශය සඳහා වසර තෝරන්න",
        translationNp: "रखरखाव म्यानुअलको वर्ष चयन गर्नुहोस्",
        translationVn: "Chọn năm của sổ tay bảo trì",
        translationPh: "Piliin ang taon ng maintenance manual",
        translationBd: "রক্ষণাবেক্ষণ ম্যানুয়ালের বছর নির্বাচন করুন"
    },

    "WelcomeDTC": {
        translationEng: "Welcome to the DTC Chatbot Portal",
        translationJp: "DTCチャットボットポータルへようこそ",
    },

    "AI Subheading": {
        translationEng: "AI-powered vehicle diagnostic and repair guidance support.",
        translationJp: "AI を活用した車両診断および修理ガイダンスのサポート。",
    },

    "Message copied to clipboard": {
        translationEng: "Message copied to clipboard",
        translationJp: "クリップボードにメッセージをコピーしました",
    },

    "Copied": {
        translationEng: "Copied",
        translationJp: "コピーしました",
    },

    "Thank You!": {
        translationEng: "Thank You!",
        translationJp: "ありがとう！",
    },

    "Your feedback was successfully submitted.": {
        translationEng: "Your feedback was successfully submitted.",
        translationJp: "フィードバックは正常に送信されました。",
    },

    "Open Sidebar": {
        translationEng: "Open Sidebar",
        translationJp: "サイドバーを開く",
    },

    "Thinking...": {
        translationEng: "Thinking...",
        translationJp: "考え中...",
        translationIn: "Berpikir...",
        translationSl: "සිතමින්...",
        translationNp: "सोच्दै...",
        translationVn: "Đang suy nghĩ...",
        translationPh: "Nag-iisip...",
        translationBd: "চিন্তা করছি..."
    },

    "Please wait for the current response": {
        translationEng: "Please wait for the current response",
        translationJp: "現在の応答をお待ちください",
        translationIn: "Harap tunggu respons saat ini",
        translationSl: "කරුණාකර වත්මන් ප්‍රතිචාරය බලා සිටින්න",
        translationNp: "कृपया हालको प्रतिक्रियाको लागि पर्खनुहोस्",
        translationVn: "Vui lòng đợi phản hồi hiện tại",
        translationPh: "Mangyaring maghintay para sa kasalukuyang tugon",
        translationBd: "বর্তমান প্রতিক্রিয়ার জন্য অপেক্ষা করুন"
    },

    "Send message": {
        translationEng: "Send message",
        translationJp: "メッセージを送信",
        translationIn: "Kirim pesan",
        translationSl: "පණිවිඩය යවන්න",
        translationNp: "सन्देश पठाउनुहोस्",
        translationVn: "Gửi tin nhắn",
        translationPh: "Magpadala ng mensahe",
        translationBd: "বার্তা পাঠান"
    },

    "Quick": {
        translationEng: "Quick",
        translationJp: "クイック"
    },

    "Deep": {
        translationEng: "Deep",
        translationJp: "ディープ"
    },

    "Response Mode": {
        translationEng: "Response Mode",
        translationJp: "回答モード"
    },

    "Fast grounded answer": {
        translationEng: "Fast grounded answer",
        translationJp: "高速な回答"
    },

    "Full search with manual references": {
        translationEng: "Full search with manual references",
        translationJp: "マニュアル参照付き完全検索"
    },

    "Vehicle Model": {
        translationEng: "Vehicle Model",
        translationJp: "車両モデル"
    },
    "Year": {
        translationEng: "Year",
        translationJp: "年式",
        translationIn: "Tahun",
        translationSl: "වර්ෂය",
        translationNp: "वर्ष",
        translationVn: "Năm",
        translationPh: "Taon",
        translationBd: "বছর"
    },

    // ── Chat revamp (src/chat) ──
    "Retry": { translationEng: "Retry", translationJp: "再試行" },
    "Source": { translationEng: "Source", translationJp: "出典" },
    "Sources": { translationEng: "Sources", translationJp: "出典" },
    "Open page": { translationEng: "Open page", translationJp: "ページを開く" },
    "Pages consulted": { translationEng: "Pages consulted", translationJp: "参照したページ" },
    "Hide other pages": { translationEng: "Hide other pages", translationJp: "他のページを隠す" },
    "more pages consulted": { translationEng: "more pages consulted", translationJp: "件の参照ページ" },
    "Figures": { translationEng: "Figures", translationJp: "図・配線図" },
    "Searching": { translationEng: "Searching", translationJp: "検索" },
    "Reading": { translationEng: "Reading", translationJp: "確認" },
    "pages": { translationEng: "pages", translationJp: "ページ" },
    "Writing": { translationEng: "Writing", translationJp: "回答作成" },
    "Quick suggestions": { translationEng: "Quick suggestions", translationJp: "関連する質問" },
    "Stop generating": { translationEng: "Stop generating", translationJp: "生成を停止" },
    "Stopped": { translationEng: "Stopped", translationJp: "停止しました" },
    "Unable to send your message. Please try again.": { translationEng: "Unable to send your message. Please try again.", translationJp: "メッセージを送信できませんでした。もう一度お試しください。" },
    "Answer complete": { translationEng: "Answer complete", translationJp: "回答が完了しました" },
    "This chat is getting long. Start a new chat for the best answers.": { translationEng: "This chat is getting long. Start a new chat for the best answers.", translationJp: "このチャットは長くなっています。より良い回答のために新しいチャットを開始してください。" },
    "turns": { translationEng: "turns", translationJp: "往復" },
    "Dismiss": { translationEng: "Dismiss", translationJp: "閉じる" },
    "Loading...": { translationEng: "Loading...", translationJp: "読み込み中..." },
    "Load earlier messages": { translationEng: "Load earlier messages", translationJp: "以前のメッセージを読み込む" },
    "Jump to latest": { translationEng: "Jump to latest", translationJp: "最新へ移動" },
    "Latest": { translationEng: "Latest", translationJp: "最新" },
    "Previous page": { translationEng: "Previous page", translationJp: "前のページ" },
    "Next page": { translationEng: "Next page", translationJp: "次のページ" },
    "Open in new tab": { translationEng: "Open full size in new tab", translationJp: "新しいタブで原寸表示" },
    "Zoom in": { translationEng: "Zoom in", translationJp: "拡大" },
    "Zoom out": { translationEng: "Zoom out", translationJp: "縮小" },
    "Download": { translationEng: "Download", translationJp: "ダウンロード" },
    "Theme": { translationEng: "Theme", translationJp: "テーマ" },
    "System": { translationEng: "System", translationJp: "システム設定" },
    "Light": { translationEng: "Light", translationJp: "ライト" },
    "Dark": { translationEng: "Dark", translationJp: "ダーク" },
    "Connection lost. Please try again.": { translationEng: "Connection lost. Please try again.", translationJp: "接続が切れました。もう一度お試しください。" },
    "The server stopped responding. Please try again.": { translationEng: "The server stopped responding. Please try again.", translationJp: "サーバーの応答がありません。もう一度お試しください。" },
    "Error": { translationEng: "Error", translationJp: "エラー" },
    "Search chats": { translationEng: "Search chats", translationJp: "チャットを検索" },
    "No matching chats": { translationEng: "No matching chats", translationJp: "一致するチャットはありません" },
    "No chats yet": { translationEng: "No chats yet", translationJp: "チャット履歴はまだありません" },
    "Untitled chat": { translationEng: "Untitled chat", translationJp: "無題のチャット" },
    "Load more": { translationEng: "Load more", translationJp: "さらに読み込む" },
    "Unable to load this conversation.": { translationEng: "Unable to load this conversation.", translationJp: "この会話を読み込めませんでした。" },
    "Older": { translationEng: "Older", translationJp: "それ以前" },
    "Message too long": { translationEng: "Message too long", translationJp: "メッセージが長すぎます" },
    "Questions must be 2000 characters or fewer.": { translationEng: "Questions must be 2000 characters or fewer.", translationJp: "質問は2000文字以内で入力してください。" },
    "Memory": { translationEng: "Memory", translationJp: "メモリー" },
    "Memory graph": { translationEng: "Memory graph", translationJp: "メモリーグラフ" },
    "Whole workspace": { translationEng: "Whole workspace", translationJp: "ワークスペース全体" },
    "This conversation": { translationEng: "This conversation", translationJp: "この会話" },
    "nodes": { translationEng: "nodes", translationJp: "ノード" },
    "edges": { translationEng: "edges", translationJp: "エッジ" },
    "Refresh": { translationEng: "Refresh", translationJp: "更新" },
    "Legend": { translationEng: "Legend", translationJp: "凡例" },
    "Memory link": { translationEng: "Memory link", translationJp: "メモリーのつながり" },
    "Manual knowledge-graph link": { translationEng: "Manual knowledge-graph link", translationJp: "マニュアルのナレッジグラフのつながり" },
    "Loading memory…": { translationEng: "Loading memory…", translationJp: "メモリーを読み込み中…" },
    "Start or open a conversation to see its memory graph.": { translationEng: "Start or open a conversation to see its memory graph.", translationJp: "会話を開始するか開くと、そのメモリーグラフが表示されます。" },
    "Nothing remembered yet. Ask a few questions first.": { translationEng: "Nothing remembered yet. Ask a few questions first.", translationJp: "まだ記憶はありません。まずいくつか質問してください。" },
    "This conversation has no remembered turns yet.": { translationEng: "This conversation has no remembered turns yet.", translationJp: "この会話にはまだ記憶されたやり取りがありません。" },
    "Everything the assistant remembers for you: your conversations, the parts, DTCs and sections they were about, the facts it learned, and how those connect in the manual.": { translationEng: "Everything the assistant remembers for you: your conversations, the parts, DTCs and sections they were about, the facts it learned, and how those connect in the manual.", translationJp: "アシスタントが記憶しているすべて：会話、そこで扱った部品・DTC・セクション、学んだ事実、そしてマニュアル上のつながり。" },
    "How the assistant followed this conversation: each question in order, what it was about (bigger = more salient in its working memory right now), the pages it used, and the manual links between them.": { translationEng: "How the assistant followed this conversation: each question in order, what it was about (bigger = more salient in its working memory right now), the pages it used, and the manual links between them.", translationJp: "アシスタントがこの会話をどう追ったか：質問の順序、各質問の対象（大きいほど現在のワーキングメモリーで重要）、使用したページ、そしてそれらのマニュアル上のつながり。" },
    "Dashboard": { translationEng: "Dashboard", translationJp: "ダッシュボード" },
    "What I know": { translationEng: "What I know", translationJp: "ナレッジ一覧" },
    "vehicle model years": { translationEng: "vehicle model years", translationJp: "車両モデル年式" },
    "manuals": { translationEng: "manuals", translationJp: "マニュアル" },
    "graph entities": { translationEng: "graph entities", translationJp: "グラフ要素" },
    "relationships": { translationEng: "relationships", translationJp: "関係" },
    "Manual pages": { translationEng: "Manual pages", translationJp: "マニュアルページ" },
    "Pages with wiring data": { translationEng: "Pages with wiring data", translationJp: "配線データのあるページ" },
    "Pages with specifications": { translationEng: "Pages with specifications", translationJp: "諸元のあるページ" },
    "DTCs": { translationEng: "DTCs", translationJp: "DTC" },
    "Components": { translationEng: "Components", translationJp: "部品" },
    "Connectors": { translationEng: "Connectors", translationJp: "コネクタ" },
    "Locations": { translationEng: "Locations", translationJp: "取付位置" },
    "Sections": { translationEng: "Sections", translationJp: "セクション" },
    "Domains": { translationEng: "Domains", translationJp: "分野" },
    "Try asking": { translationEng: "Try asking", translationJp: "質問してみる" },
    "Chapters": { translationEng: "Chapters", translationJp: "章" },
    "Filter chapters…": { translationEng: "Filter chapters…", translationJp: "章を絞り込む…" },
    "Manuals": { translationEng: "Manuals", translationJp: "マニュアル" },
    "Most connected parts": { translationEng: "Most connected parts", translationJp: "関連の多い部品" },
    "DTCs with the most suspected parts": { translationEng: "DTCs with the most suspected parts", translationJp: "推定部品の多いDTC" },
    "Loading…": { translationEng: "Loading…", translationJp: "読み込み中…" },
    "DTC diagnosis": { translationEng: "DTC diagnosis", translationJp: "DTC診断" },
    "Wiring & circuits": { translationEng: "Wiring & circuits", translationJp: "配線と回路" },
    "Installation & location": { translationEng: "Installation & location", translationJp: "取付けと位置" },
    "Specifications": { translationEng: "Specifications", translationJp: "諸元" },
    "Japanese & English": { translationEng: "Japanese & English", translationJp: "日本語と英語" },
    "Follow-ups & memory": { translationEng: "Follow-ups & memory", translationJp: "追加質問と記憶" },
    "Meaning, set conditions, suspected parts and the inspection flow for a trouble code": { translationEng: "Meaning, set conditions, suspected parts and the inspection flow for a trouble code", translationJp: "故障コードの意味、検出条件、推定部品、点検手順" },
    "Connector pins, wire colours, power supply, ground and signal paths": { translationEng: "Connector pins, wire colours, power supply, ground and signal paths", translationJp: "コネクタのピン、配線色、電源、アース、信号経路" },
    "Where a part is mounted, removal / installation steps and tightening torques": { translationEng: "Where a part is mounted, removal / installation steps and tightening torques", translationJp: "部品の取付位置、脱着手順、締付トルク" },
    "Resistance, voltage, pressure, clearance and capacity values from the spec tables": { translationEng: "Resistance, voltage, pressure, clearance and capacity values from the spec tables", translationJp: "諸元表の抵抗・電圧・圧力・すき間・容量" },
    "Every answer links the exact manual pages, with page images you can open": { translationEng: "Every answer links the exact manual pages, with page images you can open", translationJp: "回答ごとに該当マニュアルページと画像を表示" },
    "Ask in either language; the manuals are read in both": { translationEng: "Ask in either language; the manuals are read in both", translationJp: "どちらの言語でも質問できます" },
    "Remembers what each conversation is about, so “it” and “that connector” work": { translationEng: "Remembers what each conversation is about, so “it” and “that connector” work", translationJp: "会話の内容を記憶し、「それ」「そのコネクタ」も理解します" },
    "My files": { translationEng: "My files", translationJp: "マイファイル" },
    "files": { translationEng: "files", translationJp: "件のファイル" },
    "searchable": { translationEng: "searchable", translationJp: "件が検索対象" },
    "Uploading": { translationEng: "Uploading", translationJp: "アップロード中" },
    "Open": { translationEng: "Open", translationJp: "開く" },
    "Cancel": { translationEng: "Cancel", translationJp: "キャンセル" },
    "passages": { translationEng: "passages", translationJp: "パッセージ" },
    "max": { translationEng: "max", translationJp: "最大" },
    "No files yet.": { translationEng: "No files yet.", translationJp: "まだファイルはありません。" },
    "Drop files here or click to browse": { translationEng: "Drop files here or click to browse", translationJp: "ここにファイルをドロップ、またはクリックして選択" },
    "images are saved but not searchable": { translationEng: "images are saved but not searchable", translationJp: "画像は保存されますが検索対象外です" },
    "Reading…": { translationEng: "Reading…", translationJp: "読み込み中…" },
    "Searchable": { translationEng: "Searchable", translationJp: "検索可能" },
    "Saved, not searchable": { translationEng: "Saved, not searchable", translationJp: "保存済み（検索対象外）" },
    "Failed": { translationEng: "Failed", translationJp: "失敗" },
    "Reading the file…": { translationEng: "Reading the file…", translationJp: "ファイルを読み込み中…" },
    "Ready — ask about it": { translationEng: "Ready — ask about it", translationJp: "準備完了 — 質問できます" },
    "Saved (not searchable)": { translationEng: "Saved (not searchable)", translationJp: "保存済み（検索対象外）" },
    "already in your files": { translationEng: "already in your files", translationJp: "すでにファイルにあります" },
    "Attach files to your workspace": { translationEng: "Attach files to your workspace", translationJp: "ワークスペースにファイルを添付" },
    "Only you can see these files. When you ask a question, the assistant searches them together with the FUSO manuals and cites them like manual pages.": { translationEng: "Only you can see these files. When you ask a question, the assistant searches them together with the FUSO manuals and cites them like manual pages.", translationJp: "これらのファイルはあなただけが見られます。質問すると、アシスタントはFUSOマニュアルと一緒にこれらを検索し、マニュアルページと同様に出典として示します。" }
};